<template>
  <div>
    <login></login>
  </div>
</template>

<script>
import login from "@/components/Login.vue";

export default {
  methods: {
    setLayout: function(layout) {
      this.$store.commit("SET_LAYOUT", layout);
    }
  },
  mounted() {
    this.setLayout("login-layout");
  },
  components: {
    login
  }
};
</script>
